// extracted by mini-css-extract-plugin
module.exports = {"dataLabTable":"AccionaTableLaboratory_dataLabTable__2FaSs","data":"AccionaTableLaboratory_data__2sOzF"};